import React, {forwardRef} from 'react';
import {SidebarChatToggle} from './';
import {KeenIcon} from '@/components';
import {Link} from 'react-router-dom';
import {CommonHexagonBadge} from "@/partials/common";

const SidebarChatHeader = forwardRef<
    HTMLDivElement,
    { title?: string; instructions?: string; onToggle?: () => void; collapsed?: boolean }
>(({title, instructions, onToggle, collapsed}, ref) => {
    return (
        <div
            ref={ref}
            className="py-5 bg-white flex flex-col gap-5 px-2"
        >
            <div className="flex items-start justify-between gap-4">
                {/* Icon badge */}
                <CommonHexagonBadge
                    stroke="stroke-brand-clarity"
                    fill="fill-brand-light"
                    size="size-[50px]"
                    badge={<KeenIcon icon="technology-4" className="text-1.5xl ps-px text-brand"/>}
                />

                {/* Optional toggle
                {onToggle && (
                    <div className="flex-shrink-0">
                        <SidebarChatToggle/>
                    </div>
                )}*/}
            </div>

            {/* Title and instructions */}
            <div>
                {title && (
                    <h2 className="text-lg font-semibold text-gray-900 leading-tight">{title}</h2>
                )}
                {instructions && (
                    <p className="mt-1 text-sm text-gray-700 leading-snug whitespace-pre-line">
                        {instructions}
                    </p>
                )}

                {/* Learn more link
                <div className="mt-2">
                    <Link to="/learn-more-about-buddy" className="btn btn-link text-sm text-primary px-0">
                        Learn more about instructions
                    </Link>
                </div>*/}
            </div>
        </div>
    );
});

SidebarChatHeader.displayName = 'SidebarChatHeader';
export {SidebarChatHeader};
